// extracted by mini-css-extract-plugin
module.exports = {"content":"MainContentLayout_content__5GkkM","background":"MainContentLayout_background__3fEkT"};